import React from "react"

const AISparkle = ({ children, className = "" }) => {
  return <li className={`ai-sparkle ${className}`}>{children}</li>
}

export default AISparkle
